import { ActualAuctionStatusEnum } from "../_common/enum/actualAuctionStatus";
import { AuctionCatalogueStatusEnum } from "../_common/enum/auctionCatalogueStatus.enum";
import { AuctionStatusEnum } from "../_common/enum/auctionStatus.enum";

export function getActualStatus(auction: any, catalogueItem: any) {

    if (auction?.auctionStatusId == null) {
        return ActualAuctionStatusEnum.NotStarted;
    }

    if (auction?.auctionStatusId == AuctionStatusEnum.Completed) {
        return ActualAuctionStatusEnum.Completed;
    }

    if (!catalogueItem) {
        return ActualAuctionStatusEnum.NotRegistered;
    }

    if (auction?.auctionStatusId == AuctionStatusEnum.Paused) {
        return ActualAuctionStatusEnum.Paused;
    }

    if (auction?.auctionStatusId == AuctionStatusEnum.Pending) {
        return ActualAuctionStatusEnum.Pending;
    }

    if (auction?.auctionStatusId == AuctionStatusEnum.UserDisconnected) {
        return ActualAuctionStatusEnum.UserDisconnected;
    }

    if (!auction || !auction.auctionStatusId || !catalogueItem || !catalogueItem.auctionCatalogueStatusId) {
        return ActualAuctionStatusEnum.Loading;
    }

    if (auction?.auctionStatusId == AuctionStatusEnum.Active) {
        if (catalogueItem?.auctionCatalogueStatusId == AuctionCatalogueStatusEnum.Active) {
            return ActualAuctionStatusEnum.Active;
        }
        if (catalogueItem?.auctionCatalogueStatusId == AuctionCatalogueStatusEnum.BidAcceptance) {
            return ActualAuctionStatusEnum.BidAcceptance;
        }
        if (catalogueItem?.auctionCatalogueStatusId == AuctionCatalogueStatusEnum.ReOffered) {
            return ActualAuctionStatusEnum.ReOffered;
        }
        if (catalogueItem?.auctionCatalogueStatusId == AuctionCatalogueStatusEnum.Completed) {
            return ActualAuctionStatusEnum.Completed;
        }
        if (catalogueItem?.auctionCatalogueStatusId == AuctionCatalogueStatusEnum.Withdrawn) {
            return ActualAuctionStatusEnum.Withdrawn;
        }
        if (catalogueItem?.auctionCatalogueStatusId == AuctionCatalogueStatusEnum.ClosingShortly) {
            return ActualAuctionStatusEnum.ClosingShortly;
        }

        return ActualAuctionStatusEnum.Pending;
    }
    return ActualAuctionStatusEnum.InvalidStatus;
}

/** True when admin/proxy on-behalf bidding should be locked (auction paused). */
export function isOnBehalfBidPaused(actualAuctionStatusId: ActualAuctionStatusEnum): boolean {
    return actualAuctionStatusId === ActualAuctionStatusEnum.Paused
        || actualAuctionStatusId === ActualAuctionStatusEnum.UserDisconnected;
}
